var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9C92E5",
    d: "M342.906,0H69.063c-6.578,0-11.906,5.344-11.906,11.906v488.188c0,6.578,5.328,11.906,11.906,11.906h373.875   c6.563,0,11.906-5.328,11.906-11.906V111.938L342.906,0z M339.344,36.844l81.031,81.031h-81.031V36.844z M426.266,483.422H85.734   V28.578h229.797v89.938c0,6.359,2.625,12.234,6.797,16.391c4.141,4.172,10.016,6.781,16.391,6.781h87.547V483.422z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.281,
    y: 185.75,
    fill: "#9C92E5",
    width: 209.563,
    height: 23.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.281,
    y: 269.094,
    fill: "#9C92E5",
    width: 208.359,
    height: 23.813
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.281,
    y: 352.438,
    fill: "#9C92E5",
    width: 111.906,
    height: 23.828
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C92E5",
    d: "M311.031,340.219c-8.594,8.563-13.938,20.563-13.938,33.656s5.344,25.094,13.938,33.672l0.125,0.125   l-20.031,32.906l22.156,0.297l10.469,19.563l20.953-34.469l20.953,34.469l10.5-19.563l22.141-0.297l-20.047-32.906l0.141-0.125   c8.578-8.578,13.938-20.578,13.938-33.672s-5.359-25.094-13.938-33.656c-8.578-8.609-20.578-13.969-33.688-13.969   S319.594,331.609,311.031,340.219z M363.75,373.875c0,3.672-1,7.047-2.797,9.938c-0.766,1.281-1.703,2.453-2.766,3.547   c-3.188,3.141-7.344,5.188-12.094,5.516c-0.453,0.031-0.906,0.063-1.391,0.063s-0.922-0.031-1.359-0.063   c-4.75-0.328-8.938-2.375-12.125-5.516c-1.063-1.094-2-2.266-2.75-3.547c-1.813-2.891-2.813-6.266-2.813-9.938   c0-5.313,2.094-9.969,5.563-13.469c3.5-3.469,8.188-5.563,13.484-5.563c5.313,0,9.984,2.094,13.484,5.563   C361.641,363.906,363.75,368.563,363.75,373.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalDocument);
export default __webpack_public_path__ + "static/media/legal_document.0b835172620f4ac03218ba3324c1167e.svg";
export { ForwardRef as ReactComponent };